import { SpinnerCircular as Spinner } from 'spinners-react';
import styles from '../style.module.css';

type Props = {
  color?: string;
  size?: number;
};
const Loader = ({ color = 'white', size = 22 }: Props) => {
  return (
    <Spinner
      thickness={210}
      color={color}
      secondaryColor="transparent"
      size={size}
      speed={160}
      className={styles.loader}
    />
  );
};

export default Loader;
